export enum LocalStorageKeys {
  HighScore = 'highScore',
  Stats = 'stats',
  Theme = 'theme',
}
